export default function LandingFounderNote() {
    return (
        <section id="founder" className="relative scroll-mt-24 bg-white">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
                    <div data-aos="fade-right">
                        <span className="lp-chip mb-6">Founder&rsquo;s note</span>
                        <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-ink-900 leading-tight tracking-tight">
                            Building the future of longevity in India
                        </h2>
                        <div className="mt-8 space-y-5 text-ink-600 leading-[1.85] text-base lg:text-lg">
                            <p>
                                At AGEON, we are building something the world hasn&rsquo;t seen before — a destination
                                where advanced biotechnology and time-honoured healing converge to help people live
                                not just longer, but better.
                            </p>
                            <p>
                                With eight precision therapies and three diagnostic panels under one roof, AGEON
                                delivers measurable longevity, grounded in science and delivered with care. As part
                                of the EBG Group, we are backed by the infrastructure and vision to make AGEON a
                                national platform for longevity medicine.
                            </p>
                        </div>
                        <div className="mt-10 pt-8 border-t border-ink-100">
                            <p className="font-heading text-xl italic text-ink-800">Dr. Irfan Khan</p>
                            <p className="mt-1 text-sm font-medium text-brand-teal-700">Founder &amp; CEO, EBG Group</p>
                        </div>
                    </div>

                    <div className="relative flex justify-center lg:justify-end" data-aos="fade-left" data-aos-delay="120">
                        <div className="relative w-full max-w-[500px] sm:max-w-[450px]">
                            <div aria-hidden className="absolute -inset-4 rounded-[1.5rem] bg-gradient-to-br from-brand-teal/10 to-brand-gold/10 blur-xl" />
                            <div className="relative overflow-hidden ">
                                <img
                                    src="/images/irfan.png"
                                    alt="Dr. Irfan Khan — Founder & CEO, EBG Group"
                                    className="w-full aspect-[3/4] object-contain object-bottom"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
